module.exports = __webpack_public_path__ + "media/images/store_badges/app_store/app_store_es-0416db0547e03ba3a6224215fc28c1d4.png";